import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(
    private router: Router
  ) {}

  account_id = JSON.parse(localStorage.getItem('currentUser')).id

  canActivate() { 
  let  currentUser;
  currentUser = JSON.parse(localStorage.getItem('currentUser'))
    if (currentUser['roles'].includes('admin')) {
      return true;
    }
    window.alert("You don't have access to this page"); 
    this.router.navigate([`/account/${this.account_id}/accountGoals`]);
    // this.router.navigate(['dashboard']);
    return false;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/guards/admin.guard.ts